// Marketing shell — 2026 rebrand header/footer per approved mockup.
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { track } from "../lib/analytics";

const BOOKING_URL = "https://api.leadconnectorhq.com/widget/bookings/jc3-strategy-call";

const NAV = [
  { label: "Services", to: "/#services" },
  { label: "Pricing", to: "/pricing" },
  { label: "About", to: "/#about" },
  { label: "FAQ", to: "/#faq" },
];

function NavLinks({ onClick }) {
  return (
    <>
      {NAV.map((n) => (
        <Link key={n.label} to={n.to} onClick={onClick}>{n.label}</Link>
      ))}
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" onClick={() => { track("booking-cta-click", { location: "nav" }); onClick && onClick(); }}>Book a call</a>
      <Link to="/dashboard" onClick={onClick}>Dashboard</Link>
      <Link className="action" to="/dashboard/signup" data-testid="nav-get-started" onClick={onClick}>Get started</Link>
    </>
  );
}

export default function MarketingShell({ children }) {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    setOpen(false);
    if (hash) {
      const id = hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id === "approval-calculator" ? "readiness-score" : id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 60);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return (
    <div>
      <header className="site-header">
        <div className="wrap">
          <Link className="brand" to="/" data-testid="header-logo">
            <img className="logo-full" src="/jc3-logo-horizontal-on-dark.svg" width="292" height="40" alt="JC3 Wealth Legacy Group" />
            <img className="logo-crest" src="/jc3-crest-on-dark.svg" width="33" height="40" alt="JC3 Wealth Legacy Group" />
          </Link>
          <nav className="nav" aria-label="Main"><NavLinks /></nav>
          <button className="action menu-btn" type="button" aria-expanded={open} aria-controls="mobile-nav" data-testid="mobile-menu-button" onClick={() => setOpen((o) => !o)}>Menu</button>
        </div>
        <div className="mobile-nav" id="mobile-nav" hidden={!open}>
          <div className="wrap">
            <ul>
              {["Services", "Pricing", "About", "FAQ"].map((l, i) => (
                <li key={l}><Link to={NAV[i].to} onClick={() => setOpen(false)}>{l}</Link></li>
              ))}
              <li><a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>Book a call</a></li>
              <li><Link to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link></li>
              <li><Link className="action" to="/dashboard/signup" onClick={() => setOpen(false)}>Get started</Link></li>
            </ul>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer className="footer on-deep">
        <div className="wrap grid12 footer-grid">
          <div className="footer-id">
            <Link className="brand" to="/"><img src="/jc3-logo-horizontal-on-dark.svg" width="234" height="32" alt="JC3 Wealth Legacy Group" /></Link>
            <p className="small dim-dark">Veteran-owned business</p>
            <p className="measure">Build Wealth. Protect Legacy. Own Your Future.</p>
          </div>
          <div className="footer-contact small">
            <p className="h4" style={{ color: "var(--ivory)" }}>Get in touch</p>
            <a href="mailto:jace@jc3wealthlegacy.com" data-testid="footer-email">jace@jc3wealthlegacy.com</a>
            <a href="tel:+14708887331" data-testid="footer-phone">470-888-7331</a>
          </div>
          <ul className="footer-links small">
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/#about">About</Link></li>
            <li><a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">Book a Call</a></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/privacy/glba">Financial Privacy Notice</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/refund">Refund Policy</Link></li>
          </ul>
          <div className="footer-legal small dim-dark">
            <p data-testid="footer-croa-disclaimer">JC3 Wealth Legacy Group LLC provides financial education and consulting services only. We are not a credit repair organization as defined by the Credit Repair Organizations Act. We are not a licensed lender, loan broker, securities dealer, or registered investment advisor. All services are educational in nature. Results are not guaranteed and vary by individual.</p>
            <p>© {new Date().getFullYear()} JC3 Wealth Legacy Group LLC. All rights reserved. | Atlanta, Georgia</p>
            <p>Veteran-Owned · Financial consulting services only.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
